import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { exam } from "../../../../core/data/json/exam";
import dayjs from "dayjs";
import { all_routes } from "../../../router/all_routes";
import { useUserPermissions } from "../../../UserPermissionsContext";
import Cookies from "js-cookie";
import { Button, Checkbox, CheckboxChangeEvent, Spin } from "antd";
import Loader from "../../../../core/common/loader";
import CommonSelect from "../../../../core/common/commonSelect";
import {
  ColumnsType,
  FilterConfirmProps,
  FilterDropdownProps,
} from "antd/es/table/interface";
import { Select, Input } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined, CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { Toast } from "react-bootstrap";
import { format } from "date-fns";
import { DateRange } from "react-date-range";
import { InactivityContext } from "../InactivityContext";

const { Option } = Select;

type Permission = { id: number; name: string };
type Admin = {
  student_id: number;
  gender_name: string;
  admission_status_name: string;
  state_name: string;
  zone_name: string;
  branch_name: string;
  orientation_name: string;
  student_class_name: string;
  section_name: string;
  agent_name: string;
  academic_year_name: string;
  varna_student_id: string | null;
  SCS_Number: string;
  is_active: boolean;
  academic_year: number;
  gender: number;
  admission_status: number;
  state: number;
  zone: number;
  branch: number;
  orientation: number;
  student_class: number;
  section: number;
  agent: number;
  button: string;
  name: string;
  no_of_attempts: number;
};

type Agent = {
  id: number;
  username: string;
};

type Category = {
  category_id: number;
  category_name: string;
};

type SubCategory = {
  subcategory_id: number;
  subcategory_name: string;
};

interface Branch {
  branch_id: number;
  name: string;
  label: string;
}

interface Class {
  class_name_id: number;
  name: string;
  label: string;
}

interface Orientation {
  orientation_id: number;
  name: string;
  label: string;
}

type SortOrder = 'ascend' | 'descend' | null;

interface SortConfig {
  field: string;
  order: SortOrder;
}

interface Student_tag {
  id: number;
  name: string;
  short_code: string;
}


const WizklubCallBacks = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so we add 1
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${month}-${day}-${year}`;
  const defaultValue = dayjs(formattedDate);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const [admin, setAdmin] = useState<Admin[]>([]);
  const [from, setFrom] = useState();
  const [to, setTo] = useState<number>();
  const [totalCount, setTotalCount] = useState(0);
  const [toastMessage, setToastMessage] = useState("");
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const [agents, setAgents] = useState<Agent[]>([]);
  const [agentsdata, setAgentsdata] = useState([]);
  const [searchedColumn, setSearchedColumn] = useState<string>("");
  const [filteredData, setFilteredData] = useState(admin);
  // const [selectedAgent, setSelectedagent] = useState<Option | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  // const [WizklubCallBackselectedBranch, setWizklubCallBackSelectedBranch] = useState("");
  // const [selectedAgentFilter, setSelectedAgentFilter] = useState<string>("");
  // const [selectedClass, setSelectedClass] = useState<string>("");
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [AsignshowCard, setAsignShowCard] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const [classesDropdown, setClassesDropdown] = useState<Class[]>([]);
  const [targetDate, setTargetDate] = useState("");
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [dangerToastMessage, setDangerToastMessage] = useState("");
  const [categoriesDropdown, setCategoriesDropdown] = useState<Category[]>([]);
  const [subCategorydropdown, setSubCategoryDropdown] = useState<SubCategory[]>(
    []
  );
  const [studentTags, setStudentTags] = useState<Student_tag[]>([]);


  const [selectedStudentTag, setSelectedStudentTag] = useState<number>(
    Number(localStorage.getItem("wizklub_students_selected_student_tag2")) || 0
  );


  useEffect(() => {
    localStorage.setItem(
      "wizklub_students_selected_student_tag2",
      selectedStudentTag.toString()
    );
  }, [selectedStudentTag]);
  const handleClearStudentTag = () => setSelectedStudentTag(0);
  const [selectedIsLastYearPaid, setSelectedIsLastYearPaid] = useState<string>(() => {
    return localStorage.getItem('wizklubCallBackselectedIsLastYearPaid') || "";
  });
  const [sortConfigs, setSortConfigs] = useState<SortConfig[]>([]);
  const [scsSearchText, setScsSearchText] = useState("");
  const [nameSearchText, setNameText] = useState("");

  // Update localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('wizklubCallBackselectedIsLastYearPaid', selectedIsLastYearPaid);
  }, [selectedIsLastYearPaid]);

  const [nextPageNumber, setNextPageNumber] = useState<number | null>(null); // Added nextPageNumber state
  // const [startDate, setStartDate] = useState<string | null>(null);
  // const [endDate, setEndDate] = useState<string | null>(null);
  const [previousPageNumber, setPreviousPageNumber] = useState<number | null>(
    null
  ); // Added previousPageNumber state

  const [agentsDropdown, setAgentsDropdown] = useState<Agent[]>([]);
  const [orientationsDropdown, setOrientationDropdown] = useState<Orientation[]>([]);
  const [selectedOrientation, setSelectedOrientation] = useState<number>(() => {
    const saved = localStorage.getItem('WizklubCallBackselectedOrientation');
    return saved !== null ? Number(saved) : 0;
  });
  const handleClearIsLastYearPaid = () => {
    setSelectedIsLastYearPaid("");
  };
  useEffect(() => {
    localStorage.setItem('WizklubCallBackselectedOrientation', selectedOrientation.toString());
  }, [selectedOrientation]);
  const handleClearState = () => setSelectedOrientation(0);
  const [selectedPreviousOrientation, setSelectedPreviousOrientation] = useState<number>(() => {
    const saved = localStorage.getItem('callBackselectedPreviousOrientation');
    return saved !== null ? Number(saved) : 0;
  });
  useEffect(() => {
    localStorage.setItem('callBackselectedPreviousOrientation', selectedOrientation.toString());
  }, [selectedOrientation]);
  const handleClearPreviousOrientation = () => setSelectedPreviousOrientation(0);

  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const {
    wizklubCallBackSelectedClass,
    setWizklubCallBackSelectedClass,
    wizklubCallBackSelectedBranch,
    setWizklubCallBackSelectedBranch,
    wizklubCallBackSelectedBranchName,
    setWizklubCallBackSelectedBranchName,
    wizklubCallBackSelectedClassName,
    setWizklubCallBackSelectedClassName,
    wizklubCallBackSelectedCategory,
    setWizklubCallBackSelectedCategory,
    wizklubCallBackSelectedSubCategory,
    setWizklubCallBackSelectedSubCategory,
    wizklubCallBackSelectedAgent,
    setWizklubCallBackSelectedAgent,
    wizklubCallBackSelectedCategoryName,
    setWizklubCallBackSelectedCategoryName,
    wizklubCallBackSelectedSubCategoryName,
    setWizklubCallBackSelectedSubCategoryName,
    wizklubCallBackSelectedAgentName,
    setWizklubCallBackSelectedAgentName,
  } = inactivityContext;

  // const [dateRange, setDateRange] = useState(() => {
  //   // Retrieve dateRange from localStorage or initialize with default values
  //   const savedDates = localStorage.getItem("dateRange");
  //   if (savedDates) {
  //     return JSON.parse(savedDates);
  //   }
  //   const today = new Date(new Date().setHours(0, 0, 0, 0));
  //   return [
  //     {
  //       startDate: today,
  //       endDate: today,
  //       key: "selection",
  //     },
  //   ];
  // });


  // useEffect(() => {
  //   // Save dateRange to localStorage whenever it changes
  //   localStorage.setItem("dateRange", JSON.stringify(dateRange));
  // }, [dateRange]);

  // const startDate = format(dateRange[0].startDate, "yyyy-MM-dd");
  // const endDate = format(dateRange[0].endDate, "yyyy-MM-dd");
  const [dateRange, setDateRange] = useState(() => {
    const savedDates = localStorage.getItem("dateRange");
    if (savedDates) {
      const parsed = JSON.parse(savedDates);
      return parsed.map((range: any) => ({
        ...range,
        startDate: range.startDate ? new Date(range.startDate) : null,
        endDate: range.endDate ? new Date(range.endDate) : null,
      }));
    }
    // ✅ Start with null values
    return [
      {
        startDate: null,
        endDate: null,
        key: "selection",
      },
    ];
  });

  useEffect(() => {
    localStorage.setItem("dateRange", JSON.stringify(dateRange));
  }, [dateRange]);

  useEffect(() => {
    if (dateRange[0].startDate === null && dateRange[0].endDate === null) {
      handleResetData();
    }
  }, [dateRange]);

  const startDate =
    dateRange?.[0]?.startDate instanceof Date && !isNaN(dateRange[0].startDate)
      ? format(dateRange[0].startDate, "yyyy-MM-dd")
      : "";

  const endDate =
    dateRange?.[0]?.endDate instanceof Date && !isNaN(dateRange[0].endDate)
      ? format(dateRange[0].endDate, "yyyy-MM-dd")
      : "";


  const [showCalendar1, setShowCalendar1] = useState(false);

  useEffect(() => {
    if (!checkPermission("view_wizklubticket", "wizklubticket")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        wizklubCallBackSelectedBranch,
        wizklubCallBackSelectedAgent,
        wizklubCallBackSelectedClass,
        startDate || undefined,
        endDate || undefined,
        wizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        selectedOrientation,
        selectedIsLastYearPaid,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
      fetchBranches().then(setBranches);
      fetchAgentsData();
      fetchAgents();
      fetchClassesDropdown();
      fetchCategoriesDropdown().then(setCategoriesDropdown);
      fetchSubCategoriesDropdown().then(setSubCategoryDropdown);
      fetchOrientationDropdown();
      fetchStudentTag();
    }
  }, [userPermissions]);

  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };

  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-datepicker");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  const handleFetchData = () => {
    if (startDate && endDate) {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        wizklubCallBackSelectedBranch,
        wizklubCallBackSelectedAgent,
        wizklubCallBackSelectedClass,
        startDate,
        endDate,
        wizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        selectedOrientation,
        selectedIsLastYearPaid,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
      setShowCalendar1(false);
    }
  };

  const handleResetData = () => {
    // if (startDate && endDate) {
    fetchData(
      currentPage,
      pageSize,
      searchText,
      wizklubCallBackSelectedBranch,
      wizklubCallBackSelectedAgent,
      wizklubCallBackSelectedClass,
      startDate,
      endDate,
      wizklubCallBackSelectedCategory,
      wizklubCallBackSelectedSubCategory,
      selectedOrientation,
      selectedIsLastYearPaid,
      selectedPreviousOrientation,
      scsSearchText,
      nameSearchText,
      selectedStudentTag
    );
    setShowCalendar1(false);
    // }
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchGroupsData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: string,
    className: string,
    startDate = "",
    endDate = "",
    categoryName: string,
    subCategoryName: string,
    orientation: number,
    lastyearpaid: string,
    previous_orientation: number,
    scsNumber: string,
    name: string,
    sortConfigs: SortConfig[],
    student_tag: number,
  ) => {
    let apiUrl = `${webApi}/wizklub/agent_call_backs/?page=${page}&page_size=${pageSize}&student__is_last_year_paid=${lastyearpaid}`;

    if (searchText) apiUrl += `&search=${searchText}`;
    if (branchName) apiUrl += `&student__branch=${branchName}`;
    if (agentName) apiUrl += `&agent_name=${agentName}`;
    if (className) apiUrl += `&student__student_class=${className}`;
    if (startDate) apiUrl += `&from_date=${startDate}`;
    if (endDate) apiUrl += `&to_date=${endDate}`;
    if (categoryName) apiUrl += `&category=${categoryName}`;
    if (subCategoryName) apiUrl += `&subcategory=${subCategoryName}`;
    if (orientation) apiUrl += `&orientation=${orientation}`;
    if (previous_orientation) apiUrl += `&previous_orientation=${previous_orientation}`;
    if (scsNumber) apiUrl += `&SCS_Number=${scsNumber}`;
    if (name) apiUrl += `&name=${name}`;
    if (sortConfigs.length > 0) {
      const orderingParams = sortConfigs
        .map(({ field, order }) =>
          order === 'descend' ? `-${field}` : field
        )
        .join(',');
      apiUrl += `&ordering=${orderingParams}`;
    }
    if (student_tag) apiUrl += `&student_tags=${student_tag}`;

    const response = await fetch(apiUrl, options);
    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(errorData.detail || "Failed to fetch user data");
    }
    return await response.json();
  };

  const fetchAgents = async () => {
    const resposne = await fetch(`${webApi}/user/users_dropdown/`, options);
    const data = await resposne.json();
    setAgents(Array.isArray(data) ? data : []);
  };

  const fetchClassesDropdown = async () => {
    const resposne = await fetch(
      `${webApi}/branches/wizklub_class_names_dropdown/`,
      options
    );
    const data = await resposne.json();
    setClassesDropdown(data);
  };

  const fetchBranches = async () => {
    const response = await fetch(
      `${webApi}/branches/wizklub_branches_dropdown/`,
      options
    );
    const data = await response.json();
    return data;
  };

  const fetchOrientationDropdown = async () => {
    const resposne = await fetch(
      `${webApi}/branches/branches_orientation_dropdown/`,
      options
    );
    const data = await resposne.json();
    setOrientationDropdown(data.results);
  };

  const fetchStudentTag = async () => {
    const resposne = await fetch(
      `${webApi}/students/student_tags_dropdown/`,
      options
    );
    const data = await resposne.json();
    setStudentTags(data);
  };

  const fetchCategoriesDropdown = async () => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_categories_dropdown/`,
      options
    );
    const data = await response.json();
    return data;
  };

  const fetchSubCategoriesDropdown = async () => {
    const response = await fetch(
      `${webApi}/wizklub/wizklub_subcategories_dropdown/`,
      options
    );
    const data = await response.json();
    return data;
  };

  const fetchData = async (
    page: number,
    pageSize: number,
    searchText: string,
    branchName: string,
    agentName: string,
    className: string,
    startDate = "",
    endDate = "",
    categoryName: string,
    subCategoryName: string,
    orientation: number,
    lastyearpaid: string,
    previous_orientation: number,
    scsNumber: string,
    name: string,
    student_tag: number,
  ) => {
    setIsLoading(true); // Start loading
    try {
      const [groupsData] = await Promise.all([
        fetchGroupsData(
          page,
          pageSize,
          searchText,
          branchName,
          agentName,
          className,
          startDate,
          endDate,
          categoryName,
          subCategoryName,
          orientation,
          lastyearpaid,
          previous_orientation,
          scsNumber,
          name,
          sortConfigs,
          student_tag
        ),
      ]);

      setTotalPages(groupsData.total_pages);
      setAdmin(groupsData.results);
      setFilteredData(groupsData.results);
      setFrom(groupsData.from);
      setTo(groupsData.to);
      // setCurrentPage(groupsData.current_page_number);
      setTotalCount(groupsData.total_count);
      setToastMessage(groupsData.message || "submitted successfully!");
      setShowSuccessToast(true);
      setNextPageNumber(groupsData.next_page_number);
      setPreviousPageNumber(groupsData.previous_page_number);
      // Ensure agentsData is an array
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };
  const handleTableChange = (pagination: any) => {
    const { current, pageSize } = pagination;
    setCurrentPage(current);
    setPageSize(pageSize);
  };

  useEffect(() => {
    fetchData(
      currentPage,
      pageSize,
      searchText,
      wizklubCallBackSelectedBranch,
      wizklubCallBackSelectedAgent,
      wizklubCallBackSelectedClass,
      startDate || undefined,
      endDate || undefined,
      wizklubCallBackSelectedCategory,
      wizklubCallBackSelectedSubCategory,
      selectedOrientation,
      selectedIsLastYearPaid,
      selectedPreviousOrientation,
      scsSearchText,
      nameSearchText,
      selectedStudentTag
    );
  }, [
    currentPage,
    wizklubCallBackSelectedBranch,
    wizklubCallBackSelectedAgent,
    wizklubCallBackSelectedClass,
    pageSize,
    wizklubCallBackSelectedCategory,
    wizklubCallBackSelectedSubCategory,
    selectedOrientation,
    selectedIsLastYearPaid,
    selectedPreviousOrientation,
    scsSearchText,
    nameSearchText,
    sortConfigs,
    selectedStudentTag, searchText
  ]);

  const handleSearch = (value: string) => {
    setSearchText(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      fetchData(
        currentPage,
        pageSize,
        searchText,
        wizklubCallBackSelectedBranch,
        wizklubCallBackSelectedAgent,
        wizklubCallBackSelectedClass,
        startDate || undefined,
        endDate || undefined,
        wizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        selectedOrientation,
        selectedIsLastYearPaid,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    }
  };

  const agentsOptions = agents.map(
    (agent: { id: { toString: () => any }; username: any }) => ({
      value: agent.id.toString(),
      label: agent.username,
    })
  );

  const [selectedName, setSelectedName] = useState<string | null>(null);
  const [selectedSCSNumber, setSelectedSCSNumber] = useState<string | null>(
    null
  );

  useEffect(() => {
    const applyFilters = () => {
      let filtered = admin;
      if (selectedName && selectedSCSNumber) {
        filtered = filtered.filter(
          (item) =>
            item.name.includes(selectedName) &&
            item.SCS_Number.includes(selectedSCSNumber)
        );
      } else if (selectedName) {
        filtered = filtered.filter((item) => item.name.includes(selectedName));
      } else if (selectedSCSNumber) {
        filtered = filtered.filter((item) =>
          item.SCS_Number.includes(selectedSCSNumber)
        );
      }
      setFilteredData(filtered);
    };
    applyFilters();
  }, [admin]);

  const handleSelect = (
    student_id: any,
    selectedRowKeys: string[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    const selectedIds = [...selectedRowKeys];
    const index = selectedIds.indexOf(student_id);
    if (index >= 0) {
      selectedIds.splice(index, 1);
    } else {
      selectedIds.push(student_id);
    }
    setSelectedRowKeys(selectedIds);
  };

  const handleSelectAll = (
    e: CheckboxChangeEvent,
    data: { student_id: any }[],
    setSelectedRowKeys: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    if (e.target.checked) {
      const allIds = data.map((item) => item.student_id);
      setSelectedRowKeys(allIds);
    } else {
      setSelectedRowKeys([]);
    }
  };



  const fetchAgentsData = async () => {
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/teammgmt/get_team_members_by_teammgmt/2/`,
        options
      );
      const data = await response.json();
      setAgentsDropdown(data);
    } catch (error) {
      console.error("Failed to fetch agents", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleAgentChange = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/students/bulk_summer_camp_agents_change/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
          }),
        }
      );
      const data = await response.json();
      console.log("Agent updated successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        wizklubCallBackSelectedBranch,
        wizklubCallBackSelectedAgent,
        wizklubCallBackSelectedClass,
        startDate || undefined,
        endDate || undefined,
        wizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        selectedOrientation,
        selectedIsLastYearPaid,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    } catch (error) {
      console.error("Failed to update agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleExportClick = () => {
    let url = `${webApi}/exports/exprot_wizklub_call_backs/?token=${jwtToken}&from_date=${startDate}&to_date=${endDate}&search=${searchText}&student__branch=${wizklubCallBackSelectedBranch}&agent_name=${wizklubCallBackSelectedAgent}&student__student_class=${wizklubCallBackSelectedClass}&category=${wizklubCallBackSelectedCategory}&subcategory=${wizklubCallBackSelectedSubCategory}&student__is_last_year_paid=${selectedIsLastYearPaid}&SCS_Number=${scsSearchText}&name=${nameSearchText}`;

    // Add orientation only if not 0
    if (selectedOrientation !== 0) {
      url += `&orientation=${selectedOrientation}`;
    }

    // Add previous_orientation only if not 0
    if (selectedPreviousOrientation !== 0) {
      url += `&previous_orientation=${selectedPreviousOrientation}`;
    }

    if (selectedStudentTag !== 0) {
      url += `&student_tags=${selectedStudentTag}`;
    }

    window.location.href = url;
  };

  const handleAgentAssignment = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    setAgentsLoading(true);
    try {
      const response = await fetch(
        `${webApi}/agentsaletarget/assign_target_to_agent/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({
            student_ids: selectedRowKeys.join(","),
            agent: selectedAgent,
            target_date_: targetDate,
          }),
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setDangerToastMessage(data.message);
        setShowSolidDangerToast(true);
        throw new Error("Failed to assign agent");
      }

      console.log("Agent assigned successfully", data);
      setToastMessage(data.message);
      setshowSolidSuccessToast(true);
      setSelectedRowKeys([]);
      setSelectedAgent(null);
      setTargetDate("");
      setAsignShowCard(false);
      fetchData(
        currentPage,
        pageSize,
        searchText,
        wizklubCallBackSelectedBranch,
        wizklubCallBackSelectedAgent,
        wizklubCallBackSelectedClass,
        startDate || undefined,
        endDate || undefined,
        wizklubCallBackSelectedCategory,
        wizklubCallBackSelectedSubCategory,
        selectedOrientation,
        selectedIsLastYearPaid,
        selectedPreviousOrientation,
        scsSearchText,
        nameSearchText,
        selectedStudentTag
      );
    } catch (error) {
      console.error("Failed to assign agent", error);
    } finally {
      setAgentsLoading(false);
    }
  };

  const handleClassChange = async (className: string) => {
    if (className === "") {
      setWizklubCallBackSelectedClass("");
      return;
    }

    const selectedClass = classesDropdown.find(
      (branch) => branch.name === className
    );
    if (selectedClass) {
      setWizklubCallBackSelectedClass(selectedClass.class_name_id.toString());
    }
  };

  const handleCategoryChange = async (categoryName: string) => {
    if (categoryName === "") {
      setWizklubCallBackSelectedCategory("");
      return;
    }

    const selectedCategory = categoriesDropdown.find(
      (category) => category.category_name === categoryName
    );
    if (selectedCategory) {
      setWizklubCallBackSelectedCategory(
        selectedCategory.category_id.toString()
      );
    }
  };

  const handleSubCategoryChange = async (SubcategoryName: string) => {
    if (SubcategoryName === "") {
      setWizklubCallBackSelectedSubCategory("");
      return;
    }

    const selectedCategory = subCategorydropdown.find(
      (subCategory) => subCategory.subcategory_name === SubcategoryName
    );
    if (selectedCategory) {
      setWizklubCallBackSelectedSubCategory(
        selectedCategory.subcategory_id.toString()
      );
    }
  };

  const handleAgentChangeFilter1 = async (AgentName: string) => {
    if (AgentName === "") {
      setWizklubCallBackSelectedAgent("");
      return;
    }

    const selectedCategory = agentsDropdown.find(
      (subCategory) => subCategory.username === AgentName
    );
    if (selectedCategory) {
      setWizklubCallBackSelectedAgent(selectedCategory.id.toString());
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setshowSolidSuccessToast(false);
      setShowSolidDangerToast(false);
    }, 3000);
  }, [toastMessage, dangerToastMessage]);

  const handleBranchChange = (branchName: string) => {
    if (branchName === "") {
      setWizklubCallBackSelectedBranch("");
      return;
    }

    const selectedBranch = branches.find(
      (branch) => branch.name === branchName
    );
    if (selectedBranch) {
      setWizklubCallBackSelectedBranch(selectedBranch.branch_id.toString());
    }
  };

  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => {
    setShowSolidDangerToast(false);
  };
  const columns: ColumnsType<any> = [
    {
      title: "Action",
      dataIndex: "callbacktime",
      render: (_text: any, record: { callbacktime: string }) => {
        const now = new Date();
        const today = now.toDateString();
        const callbackDate = new Date(record.callbacktime).toDateString();

        let backgroundColor = "";
        if (new Date(record.callbacktime) < now) {
          backgroundColor = "rgba(255, 0, 0, 0.5)";
        } else if (callbackDate === today) {
          backgroundColor = "rgba(255, 165, 0, 0.5)";
        } else if (new Date(record.callbacktime) > now) {
          backgroundColor = "rgba(0, 255, 0, 0.5)";
        }

        return (
          <div
            style={{
              backgroundColor,
              width: "15px", // Adjust size as needed
              height: "15px",
              display: "inline-block", // Ensures it displays properly
            }}
          />
        );
      },
      key: "callbacktime",
      align: "center",
    },
    {
      title: (
        <span>
          SCS Number
          {sortConfigs.some(config => config.field === "student__SCS_Number") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__SCS_Number")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {scsSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({scsSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setScsSearchText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "SCS_Number",
      key: "SCS_Number",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search SCS Number"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setScsSearchText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
      //   record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { student_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__SCS_Number"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__SCS_Number", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Name
          {sortConfigs.some(config => config.field === "student__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {nameSearchText && (
            <span style={{ marginLeft: 8, display: "inline-flex", alignItems: "center" }}>
              <span style={{ color: "#1890ff", marginRight: 4 }}>({nameSearchText})</span>
              <CloseCircleOutlined
                onClick={() => {
                  setNameText("");
                }}
                style={{ color: "red", cursor: "pointer" }}
              />
            </span>
          )}
        </span>
      ),
      dataIndex: "name",
      key: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            placeholder="Search Name"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => {
              confirm();
              setNameText(selectedKeys[0] as string);
            }}
            style={{ marginBottom: 8, display: "block" }}
          />
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      // onFilter: (value: string, record: { SCS_Number: { toString: () => string; }; }) =>
      //   record.SCS_Number?.toString().toLowerCase().includes((value as string).toLowerCase()),
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { student_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Branch
          {sortConfigs.some(config => config.field === "student__branch__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__branch__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubCallBackSelectedBranchName
            ? ` (${wizklubCallBackSelectedBranchName})`
            : ""}
          {wizklubCallBackSelectedBranchName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubCallBackSelectedBranchName(""); // Clear branch on reset
                handleBranchChange("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "branch_name",
      key: "branch_name",
      filters: branches.map((branch) => ({
        text: branch.label,
        value: branch.name,
      })),
      onFilter: (value: any, record: Admin) =>
        record.branch_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Branch"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value) => {
              setSelectedKeys([value]);
              setWizklubCallBackSelectedBranchName(value);
              handleBranchChange(value); // Include handleBranchChange here
              confirm();
            }}
            value={selectedKeys[0]}
            style={{ width: 200 }}
          >
            {branches.map((branch) => (
              <Option key={branch.branch_id} value={branch.name}>
                {branch.label}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
              handleBranchChange("");
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__branch__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__branch__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>

          Orientation
          {sortConfigs.some(config => config.field === "student__orientation__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__orientation__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}{selectedOrientation !== 0 ? ` (${orientationsDropdown.find(state => state.orientation_id === selectedOrientation)?.name})` : ""}
          {selectedOrientation !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearState}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "orientation_name",
      key: "orientation_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Orientation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = orientationsDropdown.find((s) => s.orientation_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedOrientation(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {orientationsDropdown.map((state) => (
              <Select.Option key={state.orientation_id} value={state.orientation_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { orientation_name: string }) => record.orientation_name === value,
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__orientation__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__orientation__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>

          Previous Orientation{sortConfigs.some(config => config.field === "student__previous_orientation__name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__previous_orientation__name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}{selectedPreviousOrientation !== 0 ? ` (${orientationsDropdown.find(state => state.orientation_id === selectedPreviousOrientation)?.name})` : ""}
          {selectedPreviousOrientation !== 0 && (
            <CloseCircleOutlined
              onClick={handleClearPreviousOrientation}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>

      ),
      dataIndex: "previous_orientation_name",
      key: "previous_orientation_name",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Previous Orientation"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              const selected = orientationsDropdown.find((s) => s.orientation_id === value);
              setSelectedKeys(selected ? [selected.name] : []);
              setSelectedPreviousOrientation(value);
              confirm();
            }}
            allowClear
            filterOption={(input, option) =>
              typeof option?.children === 'string' && (option.children as string).toLowerCase().includes(input.toLowerCase())
            }
          >
            {orientationsDropdown.map((state) => (
              <Select.Option key={state.orientation_id} value={state.orientation_id}>
                {state.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
      onFilter: (value: any, record: { orientation_name: string }) => record.orientation_name === value,
      render: (_text: any, record: Admin) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__previous_orientation__name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__previous_orientation__name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },

    {
      title: (
        <span>
          Class
          {sortConfigs.some(config => config.field === "student__student_class__class_sequence") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__student_class__class_sequence")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubCallBackSelectedClassName
            ? ` (${wizklubCallBackSelectedClassName})`
            : ""}
          {wizklubCallBackSelectedClassName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubCallBackSelectedClassName(""); // Clear branch on reset
                handleClassChange("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "student_class_name",
      key: "student_class_name",
      filters: classesDropdown.map((classItem) => ({
        text: classItem.label,
        value: classItem.name,
      })),
      onFilter: (value: any, record: { student_class_name: string | any[] }) =>
        record.student_class_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Class"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setWizklubCallBackSelectedClassName(value);
              handleClassChange(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {classesDropdown.map((classItem) => (
              <Option key={classItem.class_name_id} value={classItem.name}>
                {classItem.label}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining – clearFilters may be undefined
              confirm();
              handleClassChange("");
              setWizklubCallBackSelectedClassName(""); // clear external state if needed
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__student_class__class_sequence"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__student_class__class_sequence", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          isLastYearPaid
          {sortConfigs.some(config => config.field === "student__is_last_year_paid") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "student__is_last_year_paid")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {selectedIsLastYearPaid !== "" && (
            <>
              {`${selectedIsLastYearPaid ? ' (Yes)' : ' (No)'}`}
              <CloseCircleOutlined
                onClick={handleClearIsLastYearPaid}
                style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
              />
            </>
          )}
        </span>
      ),
      dataIndex: "is_last_year_paid",
      key: "is_last_year_paid",
      render: (value: boolean) => (value ? "Yes" : "No"),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
        <div style={{ padding: 8 }}>
          <Select
            placeholder="Select Payment Status"
            style={{ width: 188 }}
            value={selectedKeys[0]}
            onChange={(value) => {
              setSelectedKeys([value]);
              setSelectedIsLastYearPaid(value); // <-- Updated state handler
              confirm();
            }}
            allowClear
          >
            <Select.Option value={true}>Yes</Select.Option>
            <Select.Option value={false}>No</Select.Option>
          </Select>
        </div>
      ),
      // onFilter: (value: boolean, record: { is_last_year_paid: boolean }) =>
      //   record.is_last_year_paid === value,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "student__is_last_year_paid"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "student__is_last_year_paid", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (<span>Time {sortConfigs.some(config => config.field === "call_back_time") && (
        <span style={{ marginLeft: 8 }}>
          {sortConfigs.find(config => config.field === "call_back_time")?.order === 'ascend' ? (
            <ArrowUpOutlined style={{ color: '#1890ff' }} />
          ) : (
            <ArrowDownOutlined style={{ color: '#1890ff' }} />
          )}
        </span>
      )}</span>),
      dataIndex: "callbacktime",
      render: (
        text:
          | string
          | number
          | boolean
          | React.ReactElement<any, string | React.JSXElementConstructor<any>>
          | Iterable<React.ReactNode>
          | React.ReactPortal
          | null
          | undefined,
        record: { no_of_attempts: number; student_id: any }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "call_back_time"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "call_back_time", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },

    {
      title: (
        <span>
          Category
          {sortConfigs.some(config => config.field === "category__category_name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "category__category_name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubCallBackSelectedCategoryName
            ? ` (${wizklubCallBackSelectedCategoryName})`
            : ""}
          {wizklubCallBackSelectedCategoryName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubCallBackSelectedCategoryName(""); // Clear branch on reset
                handleCategoryChange("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "category_name",
      key: "category_name",
      filters: categoriesDropdown.map((classItem) => ({
        text: classItem.category_id,
        value: classItem.category_name,
      })),
      onFilter: (value: any, record: { category_name: string | any[] }) =>
        record.category_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Category"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setWizklubCallBackSelectedCategoryName(value);
              handleCategoryChange(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {categoriesDropdown.map((category) => (
              <Option key={category.category_id} value={category.category_name}>
                {category.category_name}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining as clearFilters may be undefined
              confirm();
              handleCategoryChange("");
              setWizklubCallBackSelectedCategoryName(""); // clear external state if needed
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "category__category_name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "category__category_name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Sub Category
          {sortConfigs.some(config => config.field === "subcategory__subcategory_name") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "subcategory__subcategory_name")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubCallBackSelectedSubCategoryName
            ? ` (${wizklubCallBackSelectedSubCategoryName})`
            : ""}
          {wizklubCallBackSelectedSubCategoryName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubCallBackSelectedSubCategoryName(""); // Clear branch on reset
                handleSubCategoryChange("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "sub_category_name",
      key: "sub_category_name",
      filters: subCategorydropdown.map((classItem) => ({
        text: classItem.subcategory_id,
        value: classItem.subcategory_name,
      })),
      onFilter: (value: any, record: { sub_category_name: string | any[] }) =>
        record.sub_category_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Sub Category"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setWizklubCallBackSelectedSubCategoryName(value);
              handleSubCategoryChange(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {subCategorydropdown.map((item) => (
              <Option key={item.subcategory_id} value={item.subcategory_name}>
                {item.subcategory_name}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining – clearFilters may be undefined
              confirm();
              handleSubCategoryChange("");
              setWizklubCallBackSelectedSubCategoryName(""); // clear external state if needed
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "subcategory__subcategory_name"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "subcategory__subcategory_name", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    {
      title: (
        <span>
          Agent
          {sortConfigs.some(config => config.field === "agent__username") && (
            <span style={{ marginLeft: 8 }}>
              {sortConfigs.find(config => config.field === "agent__username")?.order === 'ascend' ? (
                <ArrowUpOutlined style={{ color: '#1890ff' }} />
              ) : (
                <ArrowDownOutlined style={{ color: '#1890ff' }} />
              )}
            </span>
          )}
          {wizklubCallBackSelectedAgentName
            ? ` (${wizklubCallBackSelectedAgentName})`
            : ""}
          {wizklubCallBackSelectedAgentName && (
            <CloseCircleOutlined
              onClick={() => {
                setWizklubCallBackSelectedAgentName(""); // Clear branch on reset
                handleAgentChangeFilter1("");
                // confirm();
              }}
              style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
            />
          )}
        </span>
      ),
      dataIndex: "agent_name",
      key: "agent_name",
      filters: agentsDropdown.map((classItem) => ({
        text: classItem.id,
        value: classItem.username,
      })),
      onFilter: (value: any, record: { agent_name?: string | any[] | null }) =>
        !!record.agent_name && record.agent_name.includes(value),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: FilterDropdownProps) => (
        <div style={{ padding: 8 }}>
          <Select
            showSearch
            placeholder="Select Agent"
            onSearch={(value) => setSelectedKeys(value ? [value] : [])}
            onSelect={(value: string) => {
              setSelectedKeys([value]);
              setWizklubCallBackSelectedAgentName(value);
              handleAgentChangeFilter1(value);
              confirm();
            }}
            value={selectedKeys[0] ? String(selectedKeys[0]) : undefined}
            style={{ width: 200 }}
          >
            {agentsDropdown.map((agent) => (
              <Option key={agent.id} value={agent.username}>
                {agent.username}
              </Option>
            ))}
          </Select>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters?.(); // optional chaining – clearFilters may be undefined
              confirm();
              handleAgentChangeFilter1("");
              setWizklubCallBackSelectedAgentName(""); // clear external state if needed
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      ),
      render: (
        _text: any,
        record: { student_id: any; no_of_attempts: number }
      ) => (
        <Link
          to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
        >
          {_text}
        </Link>
      ),
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: () => ({
        onClick: () => {
          const newSortConfigs = [...sortConfigs];
          const existingSortIndex = newSortConfigs.findIndex(
            (config) => config.field === "agent__username"
          );

          // Cycle through sorting states (ascend → descend → remove)
          if (existingSortIndex >= 0) {
            const currentOrder = newSortConfigs[existingSortIndex].order;
            if (currentOrder === 'ascend') {
              newSortConfigs[existingSortIndex].order = 'descend';
            } else {
              newSortConfigs.splice(existingSortIndex, 1); // Remove if already descending
            }
          } else {
            newSortConfigs.push({ field: "agent__username", order: "ascend" });
          }

          setSortConfigs(newSortConfigs);
        },
      }),
    },
    // {
    //   title: (
    //     <span>
    //       Student Tag
    //       {selectedStudentTag !== 0
    //         ? ` (${
    //             studentTags.find(
    //               (state) => state.id === selectedStudentTag
    //             )?.name
    //           })`
    //         : ""}
    //       {selectedStudentTag !== 0 && (
    //         <CloseCircleOutlined
    //           onClick={handleClearStudentTag}
    //           style={{ marginLeft: 8, color: "red", cursor: "pointer" }}
    //         />
    //       )}
    //     </span>
    //   ),
    //   dataIndex: "student_tag_names",
    //   key: "student_tag_names",
    //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }: any) => (
    //     <div style={{ padding: 8 }}>
    //       <Select
    //         showSearch
    //         placeholder="Select Department"
    //         style={{ width: 188 }}
    //         value={selectedKeys[0]}
    //         onChange={(value) => {
    //           const selected = studentTags.find(
    //             (s) => s.id === value
    //           );
    //           setSelectedKeys(selected ? [selected.name] : []);
    //           setSelectedStudentTag(value);
    //           confirm();
    //         }}
    //         allowClear
    //         filterOption={(input, option) =>
    //           typeof option?.children === "string" &&
    //           (option.children as string)
    //             .toLowerCase()
    //             .includes(input.toLowerCase())
    //         }
    //       >
    //         {studentTags.map((state) => (
    //           <Select.Option
    //             key={state.id}
    //             value={state.id}
    //           >
    //             {state.name}
    //           </Select.Option>
    //         ))}
    //       </Select>
    //     </div>
    //   ),
    //   onFilter: (value: any, record: { department_name: string }) =>
    //     record.department_name === value,
    //    render: (_text: any, record: Admin) => (
    //     <Link
    //       to={`${routes.addOrUpdateWizklubTicket}?id=${record.student_id}&r1=5`}
    //     >
    //       {_text}
    //     </Link>
    //   ),
    // },
  ];

  const Preloader = () => {
    return (
      <div id="global-loader">
        <div className="page-loader"></div>
      </div>
    );
  };

  useEffect(() => {
    console.log(selectedRowKeys);
  }, [selectedRowKeys]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Wizklub CallBack Data</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard1}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CallBack Data
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {checkPermission("can_export_wizklub_call_backs", "Exports") && (
                <button className="btn btn-primary me-2" onClick={handleExportClick} >
                  Export
                </button>
              )}
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div
            className="card "
            style={{
              width: "100%",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              borderRadius: "10px",
            }}
          >
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Students List</h4>

              <div className="d-flex align-items-center flex-wrap">
                {/* <Checkbox
                    indeterminate={
                      selectedRowKeys.length > 0 &&
                      selectedRowKeys.length < admin.length
                    }
                    checked={selectedRowKeys.length === admin.length}
                    onChange={(e) =>
                      handleSelectAll(e, admin, setSelectedRowKeys)
                    }
                  >
                    Select All
                  </Checkbox>
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px" }}
                  >
                    Change Agent
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => setAsignShowCard(true)}
                    disabled={selectedRowKeys.length === 0}
                    style={{ marginLeft: "10px", marginBottom: "5px", marginRight:"5px" }}
                  >
                    Assign Agent
                  </button> */}
                <div style={{ position: "relative" }}>
                  <div
                    onClick={() => setShowCalendar1(!showCalendar1)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      background: "white",
                      borderRadius: "20px",
                      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: "#34303D",
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      minWidth: "200px",
                      justifyContent: "center",
                      marginRight: "5px",
                      marginBottom: "7px",
                    }}
                  >
                    {dateRange[0].startDate && dateRange[0].endDate
                      ? `${format(dateRange[0].startDate, "dd MMM yy")} – ${format(dateRange[0].endDate, "dd MMM yy")}`
                      : "Choose date"}
                    <span style={{ marginLeft: "10px" }}>▼</span>
                  </div>

                  {showCalendar1 && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 2000,
                        // background: "white",
                        // borderRadius: "10px",
                        // boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                        // padding: "5px",
                        // left: "-130px",
                      }}
                    >
                      <DateRange
                        ranges={dateRange}
                        onChange={(item) =>
                          setDateRange([
                            {
                              startDate: item.selection.startDate || null,
                              endDate: item.selection.endDate || null,
                              key: "selection",
                            },
                          ])
                        }
                        moveRangeOnFirstSelection={false}
                        rangeColors={["blue"]}
                      />
                    </div>
                  )}
                </div>

                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#28a745",
                    borderColor: "#28a745",
                    color: "#fff",
                    height: "38px",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    // marginTop: "0.5rem",
                    marginBottom: "7px",
                    borderRadius: "19px",
                  }}
                  onClick={handleFetchData}
                >
                  Search
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#dc3545", // Red background
                    borderColor: "#dc3545",     // Red border
                    color: "#fff",
                    height: "38px",
                    padding: "6px 12px",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "7px",
                    borderRadius: "19px",
                    marginLeft: "5px",
                  }}
                  onClick={() => {

                    setDateRange([
                      {
                        startDate: null,
                        endDate: null,
                        key: "selection",
                      },
                    ]);
                    // handleResetData()
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
            <div className="card-body p-0 py-3">

              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100vh",
                    paddingTop: "20px",
                  }}
                >
                  <Spin /> {/* Display loader while loading */}
                </div>
              ) : (
                <>
                  <Table
                    columns={columns}
                    dataSource={filteredData}
                    Selection={false}
                    pagination={{
                      current: currentPage,
                      pageSize: pageSize,
                      locale: { items_per_page: "" },
                      nextIcon: <span>Next</span>,
                      prevIcon: <span>Prev</span>,
                      defaultPageSize: 10,
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                      total: totalCount,
                      showTotal: (total: any, range: any[]) =>
                        `${range[0]}-${range[1]} of ${total}`,
                    }}
                    onChange={handleTableChange} // Move this outside of pagination
                    onSearch={handleSearch}
                    searchText={searchText}
                  />
                </>
              )}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        {showCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              {/* <div className="card-header">
                <h4
                  className="modal-title"
                  style={{
                    color: "#333",
                    marginBottom: "15px",
                  }}
                >
                  Change Agent
                </h4>
              </div> */}
              <form onSubmit={handleAgentChange}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}
        {AsignshowCard && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1049,
              }}
            />
            <div
              className="card"
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "20%",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                borderRadius: "10px",
                zIndex: 1050,
                backgroundColor: "#f9f9f9",
                padding: "20px",
              }}
            >
              <form onSubmit={handleAgentAssignment}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Select Agent
                        </label>
                        {agentsLoading ? (
                          <Spin />
                        ) : (
                          <Select
                            value={selectedAgent}
                            onChange={(value) => setSelectedAgent(value)}
                            style={{
                              width: "100%",
                            }}
                          >
                            {agentsDropdown.map((agent) => (
                              <Option key={agent.id} value={agent.id}>
                                {agent.username}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </div>
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            paddingBottom: "10px",
                            fontWeight: "bold",
                            color: "#555",
                          }}
                        >
                          Target Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={targetDate}
                          onChange={(e) => setTargetDate(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    onClick={() => setAsignShowCard(false)}
                  >
                    Cancel
                  </Button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={agentsLoading}
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </>
        )}

        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}

        <Toast
          show={showSolidSuccessToast}
          onClose={handleSolidSuccessToastClose}
          id="solidSuccessToast"
          className="colored-toast bg-success text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>

        <Toast
          show={showSolidDangerToast}
          onClose={handleSolidDangerToastClose}
          id="solidDangerToast"
          className="colored-toast bg-danger text-fixed-white"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 1050,
          }}
        >
          <Toast.Body>{dangerToastMessage}</Toast.Body>
        </Toast>
      </>
    </div>
  );
};

export default WizklubCallBacks;
